module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: _vm.component_class,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.is_loading) ? _c('Icon', {
    attrs: {
      "name": "loading",
      "rotate": true
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.is_loading && _vm.prefix) ? _c('Icon', {
    attrs: {
      "name": _vm.prefix
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading_text) ? _c('span', [_vm._v("\n    " + _vm._s(_vm.loading_text) + "\n  ")]) : _c('span', [_vm._t("default")], 2), _vm._v(" "), (!_vm.is_loading && _vm.suffix) ? _c('Icon', {
    attrs: {
      "name": _vm.suffix
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff689ea6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Btn/Btn.vue
// module id = 697
// module chunks = 0